/**
 * The one strictly-increasing `opId` counter of one connection. Raid drags,
 * menu drags and trader clicks are all answered by the SAME `invResult` in the
 * SAME id space, so there is exactly one counter, outside all three
 * controllers. An id is only spent on a message actually sent, so the sequence
 * has no holes.
 */
export class OpIds {
  private n = 0;

  /** The next id. Never returns the same number twice. */
  next(): number {
    this.n += 1;
    return this.n;
  }
}
